<script lang="ts">
  // Privacy Policy page component
</script>

<div class="container mx-auto px-4 py-8">
  <h1 class="text-3xl font-bold mb-6">Privacy Policy</h1>
  
  <div class="prose max-w-none">
    <p class="text-sm mt-2 mb-6">
      This privacy policy explains how we collect, use, and protect your personal information when you visit our website.
    </p>

    <h3 class="text-2xl font-semibold mt-6 mb-4">Information We Collect</h3>
    <p class="text-sm mt-2 mb-6">
      We collect information that you provide directly to us, such as when you contact us through our website.
    </p>

    <h3 class="text-2xl font-semibold mt-6 mb-4">How We Use Your Information</h3>
    <p class="text-sm mt-2 mb-6">
      We use the information we collect to:
    </p>
    <ul class="list-disc pl-6 mb-6 text-sm">
      <li>Respond to your inquiries</li>
      <li>Improve our website</li>
      <li>Send you updates about our services</li>
    </ul>

    <h3 class="text-2xl font-semibold mt-6 mb-4">Contact Us</h3>
    <p class="text-sm mt-2 mb-6">
      If you have any questions about this privacy policy, please contact us at:<br />
      Email: mail[at]jonas-loh.com
    </p>
  </div>
</div> 